// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Helmet } from "react-helmet-async"; // Add Helmet for SEO
// import {
//   Check,
//   X,
//   Copy,
//   Download,
//   Share,
//   ThumbsUp,
//   ThumbsDown,
//   TrendingUp,
//   Users,
//   Target,
//   ShieldAlert,
//   MessageCircle,
//   ArrowRight,
//   ArrowUpRight,
//   ChevronsLeftIcon,
// } from "lucide-react";
// import validatorApi from "../services/validatorApi";
// import EnhancedHeader from "./EnhancedHeader";
// import EnhancedFooter from "./Footer";

// // Toggle between mock data and real API
// const USE_REAL_API = true; // Set to true to use the actual API

// // Mock data for demonstration when API is not used
// const MOCK_RESULTS = {
//   "mock-default": {
//     idea: "A nutrition app that connects users with personal coaches for daily meal guidance and accountability",
//     industry: "Health & Wellness",
//     created_at: new Date().toISOString(),
//     demand_score: 72,
//     sources: ["r/startups", "r/fitness", "r/freelance"],
//     market_signals: [
//       '"Nutrition coaching app" was mentioned 142+ times in the last 3 months.',
//       "Tools like Cronometer and MyFitnessPal have active community interest.",
//       "Top unmet need: Personalized plan creation and remote accountability.",
//     ],
//     competitors: ["Cronometer", "BetterMe", "NutriCheck"],
//     risks: ["Users trust influencers more than apps in this space.", "Retention is hard without social features."],
//     recommended_angle: "Make it feel like having a personal coach, not just a tracker.",
//     sentiment: [
//       "Need a simple way to get nutrition plans — sick of apps that feel like calorie spreadsheets.",
//       "Why can't a coach just message me directly and give me what to eat?",
//     ],
//   },
// };

// const FreeIdeaValidatorResultsPage = () => {
//   const params = useParams();
//   const { id } = params;
//   const navigate = useNavigate();
//   const [result, setResult] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [voted, setVoted] = useState(null);
//   const [copied, setCopied] = useState(false);

//   // Base URL for canonical URLs
//   const baseUrl = "https://feedbackbyai.com";
//   const canonicalUrl = `${baseUrl}/ideavalidatorresult/${id}`;

//   // Fetch result on page load
//   useEffect(() => {
//     const fetchResult = async () => {
//       console.log("idea is -->", id);
//       if (!id) return;
//       try {
//         setLoading(true);
//         if (USE_REAL_API) {
//           // Use the real API
//           const response = await validatorApi.getValidationResult(id);
//           if (response.success) {
//             setResult(response.data);
//             document.title = `Startup Validation Results: ${response.data.idea.substring(0, 60)}... | FeedbackbyAI`;
//             updateMetaTags(response.data);
//           } else {
//             setError(response.error || "Failed to load results");
//           }
//         } else {
//           // Use mock data
//           setTimeout(() => {
//             // Check if ID starts with mock- prefix
//             if (id.startsWith("mock-")) {
//               // Get the specific mock or default to the first one
//               const mockResult = MOCK_RESULTS[id] || MOCK_RESULTS["mock-default"];
//               setResult({ ...mockResult, request_id: id });
//               document.title = `Startup Validation Results: ${mockResult.idea.substring(0, 60)}... | FeedbackbyAI`;
//               updateMetaTags(mockResult);
//             } else {
//               setError("Invalid result ID");
//             }
//           }, 1000);
//         }
//       } catch (err) {
//         setError("There was a problem loading the validation results");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchResult();
//   }, [id]);

//   // Enhanced meta tag handling with more SEO-friendly data
//   const updateMetaTags = (data) => {
//     // Create SEO-friendly description from validation results
//     const pageDescription = `Startup idea validation results: "${data.idea.substring(0, 100)}..." scored ${
//       data.demand_score
//     }/100. See market signals, competitors, risks, and recommendations based on real data.`;

//     // Function to update or create meta tags
//     const updateMetaTag = (selector, attribute, value) => {
//       let element = document.querySelector(selector);
//       if (element) {
//         element.setAttribute(attribute, value);
//       } else {
//         element = document.createElement("meta");
//         if (selector.includes("property=")) {
//           element.setAttribute("property", selector.split("property=")[1].replace(/['"]/g, ""));
//         } else if (selector.includes("name=")) {
//           element.setAttribute("name", selector.split("name=")[1].replace(/['"]/g, ""));
//         }
//         element.setAttribute(attribute, value);
//         document.head.appendChild(element);
//       }
//     };

//     // Create title with primary keyword and branding
//     const pageTitle = `Startup Validation Results: ${data.idea.substring(0, 60)}... | FeedbackbyAI`;
//     document.title = pageTitle;

//     // Update basic meta
//     updateMetaTag('meta[name="description"]', "content", pageDescription);
//     updateMetaTag(
//       'meta[name="keywords"]',
//       "content",
//       `startup validation results, business idea validation, ${
//         data.industry || "startup"
//       } validation, market demand analysis, startup feedback, business idea score`
//     );

//     // Update OpenGraph tags
//     updateMetaTag('meta[property="og:title"]', "content", pageTitle);
//     updateMetaTag('meta[property="og:description"]', "content", pageDescription);
//     updateMetaTag('meta[property="og:url"]', "content", canonicalUrl);
//     updateMetaTag('meta[property="og:type"]', "content", "website");
//     updateMetaTag(
//       'meta[property="og:image"]',
//       "content",
//       `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
//     );

//     // Update Twitter Card tags
//     updateMetaTag('meta[name="twitter:card"]', "content", "summary_large_image");
//     updateMetaTag('meta[name="twitter:title"]', "content", pageTitle);
//     updateMetaTag('meta[name="twitter:description"]', "content", pageDescription);
//     updateMetaTag(
//       'meta[name="twitter:image"]',
//       "content",
//       `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
//     );

//     // Add canonical URL
//     let canonicalElement = document.querySelector('link[rel="canonical"]');
//     if (!canonicalElement) {
//       canonicalElement = document.createElement("link");
//       canonicalElement.setAttribute("rel", "canonical");
//       document.head.appendChild(canonicalElement);
//     }
//     canonicalElement.setAttribute("href", canonicalUrl);

//     // Add structured data for rich snippets
//     let scriptElement = document.querySelector('script[type="application/ld+json"]');
//     if (!scriptElement) {
//       scriptElement = document.createElement("script");
//       scriptElement.setAttribute("type", "application/ld+json");
//       document.head.appendChild(scriptElement);
//     }

//     const structuredData = {
//       "@context": "https://schema.org",
//       "@type": "Product",
//       name: `Startup Idea: ${data.idea.substring(0, 60)}...`,
//       description: data.recommended_angle,
//       aggregateRating: {
//         "@type": "AggregateRating",
//         ratingValue: data.demand_score,
//         bestRating: "100",
//         worstRating: "0",
//         reviewCount: "1",
//       },
//       offers: {
//         "@type": "Offer",
//         price: "0",
//         priceCurrency: "USD",
//         availability: "https://schema.org/InStock",
//       },
//       category: data.industry || "Startup",
//       brand: {
//         "@type": "Brand",
//         name: "FeedbackbyAI",
//       },
//     };

//     scriptElement.textContent = JSON.stringify(structuredData);
//   };

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(window.location.href);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const handleFeedback = async (feedbackType) => {
//     if (voted || !result) return;
//     // Optimistic UI update
//     setVoted(feedbackType);
//     // The key issue: We need to send the correct ID - we need the validation RESULT ID,
//     // not the request UUID.
//     console.log("Full result object:", result);
//     // Try to find the validation result ID
//     // From Django we see 'result_id = serializer.validated_data['result'].id'
//     // This means the serializer expects a result ID
//     const resultId = result.request_id;
//     console.log("Using result ID:", resultId);
//     try {
//       const response = await validatorApi.submitFeedback(resultId, feedbackType);
//       if (!response.success) {
//         console.error("Feedback submission failed:", response.error);
//       }
//     } catch (err) {
//       console.error("Error in feedback submission:", err);
//     }
//   };

//   const shareOnTwitter = () => {
//     if (!result) return;
//     const text = `I validated my startup idea using FeedbackbyAI and got a ${result.demand_score}/100 demand score. Check it out:`;
//     const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.location.href)}`;
//     window.open(url, "_blank");
//   };

//   const shareOnLinkedIn = () => {
//     const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
//     window.open(url, "_blank");
//   };

//   // Generate SEO-friendly meta for React Helmet
//   const generateHelmetMeta = () => {
//     if (!result) return null;

//     const pageTitle = `Startup Validation Results: ${result.idea.substring(0, 60)}... | FeedbackbyAI`;
//     const pageDescription = `Startup idea validation results: "${result.idea.substring(0, 100)}..." scored ${
//       result.demand_score
//     }/100. See market signals, competitors, risks, and recommendations based on real data.`;

//     return (
//       <Helmet>
//         <title>{pageTitle}</title>
//         <meta name="description" content={pageDescription} />
//         <meta
//           name="keywords"
//           content={`startup validation results, business idea validation, ${
//             result.industry || "startup"
//           } validation, market demand analysis, startup feedback, business idea score`}
//         />
//         <link rel="canonical" href={canonicalUrl} />

//         {/* OpenGraph / Facebook */}
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={canonicalUrl} />
//         <meta property="og:title" content={pageTitle} />
//         <meta property="og:description" content={pageDescription} />
//         <meta
//           property="og:image"
//           content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
//         />

//         {/* Twitter Card */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:url" content={canonicalUrl} />
//         <meta name="twitter:title" content={pageTitle} />
//         <meta name="twitter:description" content={pageDescription} />
//         <meta
//           name="twitter:image"
//           content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
//         />

//         {/* Schema.org structured data for Rich Snippets */}
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "Product",
//             name: `Startup Idea: ${result.idea.substring(0, 60)}...`,
//             description: result.recommended_angle,
//             aggregateRating: {
//               "@type": "AggregateRating",
//               ratingValue: result.demand_score,
//               bestRating: "100",
//               worstRating: "0",
//               reviewCount: "1",
//             },
//             offers: {
//               "@type": "Offer",
//               price: "0",
//               priceCurrency: "USD",
//               availability: "https://schema.org/InStock",
//             },
//             category: result.industry || "Startup",
//             brand: {
//               "@type": "Brand",
//               name: "FeedbackbyAI",
//             },
//           })}
//         </script>
//       </Helmet>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-emerald-200 border-t-emerald-600 rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading your validation results...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <EnhancedHeader />
//         <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
//           <X className="h-12 w-12 text-red-500 mx-auto mb-4" />
//           <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to load results</h1>
//           <p className="text-gray-600 mb-6">{error}</p>
//           <button
//             onClick={() => navigate("/")}
//             className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
//           >
//             Go to homepage
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!result) return null;

//   return (
//     <div className="min-h-screen bg-gray-50 pb-16">
//       {/* React Helmet for SEO */}
//       {generateHelmetMeta()}

//       {/* Header */}
//       <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-lg bg-white/80 border-b border-gray-200">
//         <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
//               <div className="inline-flex items-center justify-center h-8 w-8 rounded-lg mr-2 bg-gradient-to-br from-emerald-500 to-teal-500">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="h-4 w-4 text-white"
//                 >
//                   <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
//                   <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
//                 </svg>
//               </div>
//               <span className="font-semibold text-base">FeedbackbyAI</span>
//             </div>
//             <div className="hidden md:flex space-x-4 items-center">
//               <a href="/ideate/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 Brainstorm Idea
//               </a>
//               <a href="/dynamicreports/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 100+ Page Business Plan
//               </a>
//               <a href="/leadfinder/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 Buyer Intent Search
//               </a>
//               <a href="/video/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 TikTok & Reels
//               </a>
//               <a
//                 href="/tools/free-startup-idea-validator/"
//                 className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium"
//               >
//                 Validate your idea
//               </a>
//               <a
//                 href="/"
//                 className="text-sm px-4 py-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white transition-all flex items-center"
//               >
//                 Full Report <ArrowUpRight className="ml-1 h-3 w-3" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </nav>
//       {/* Main Content */}
//       <main className="pt-24 px-4 max-w-4xl mx-auto pb-5 ">
//         <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-8">
//           {/* Sharing bar */}
//           <div className="p-5 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 bg-gray-50">
//             <div className="flex-1">
//               <p className="text-sm font-medium text-gray-700 mb-2">Share these results</p>
//               <div className="flex rounded-lg overflow-hidden border border-gray-200">
//                 <input type="text" readOnly value={window.location.href} className="flex-1 px-3 py-2 text-sm text-gray-600 bg-white" />
//                 <button
//                   onClick={copyToClipboard}
//                   className={`flex items-center justify-center px-3 border-l border-gray-200 ${
//                     copied ? "bg-emerald-50 text-emerald-600" : "bg-white text-gray-500 hover:text-gray-700"
//                   }`}
//                 >
//                   {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
//                 </button>
//               </div>
//             </div>
//             <div className="flex items-stretch sm:items-center gap-2">
//               <button
//                 onClick={shareOnTwitter}
//                 className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
//               >
//                 <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
//                 </svg>
//                 <span className="sm:hidden md:inline">Twitter</span>
//               </button>
//               <button
//                 onClick={() => {
//                   // Download PDF logic would go here
//                   alert("PDF download will be available soon!");
//                 }}
//                 className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
//               >
//                 <Download className="h-4 w-4" />
//                 <span className="sm:hidden md:inline">Download</span>
//               </button>
//             </div>
//           </div>
//           {/* Report title */}
//           <div className="p-5 border-b border-gray-200">
//             <div className="max-w-2xl">
//               <h1 className="text-xl font-semibold text-gray-900 mb-1">
//                 ✅ Validation Report: {result.idea.length > 60 ? `${result.idea.substring(0, 60)}...` : result.idea}
//               </h1>
//               <p className="text-sm text-gray-500">
//                 {result.industry ? `Industry: ${result.industry}` : "No industry specified"} • Validated on{" "}
//                 {new Date(result.created_at).toLocaleDateString()}
//               </p>
//             </div>
//           </div>
//           {/* Report content */}
//           <div className="p-6 font-mono text-sm">
//             <div className="flex items-center gap-2 font-semibold text-emerald-700 mb-6">
//               <Check className="h-5 w-5" />
//               <span>Startup Validation Report — v0.1</span>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-center gap-2 font-semibold">
//                 <TrendingUp className="h-4 w-4 text-emerald-600" />
//                 <span>Demand Score: {result.demand_score}/100</span>
//               </div>
//               <div className="text-gray-600 ml-6 mt-1">→ Based on recent Reddit threads in {result.sources.join(", ")}.</div>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <svg className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//                 <span>Market Signals:</span>
//               </div>
//               <ul className="ml-6 space-y-2 mt-2">
//                 {result.market_signals.map((signal, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <span className="mr-2 text-emerald-700">•</span>
//                     <span>{signal}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <Users className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                 <span>Top Overlapping Competitors:</span>
//               </div>
//               <ul className="ml-6 space-y-2 mt-2">
//                 {result.competitors.map((competitor, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <span className="mr-2 text-emerald-700">•</span>
//                     <span>{competitor}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <ShieldAlert className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                 <span>Risks:</span>
//               </div>
//               <ul className="ml-6 space-y-2 mt-2">
//                 {result.risks.map((risk, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <span className="mr-2 text-emerald-700">•</span>
//                     <span>{risk}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <Target className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                 <span>Recommended Angle:</span>
//               </div>
//               <div className="ml-6 mt-2 italic text-emerald-800 font-medium">"{result.recommended_angle}"</div>
//             </div>
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <MessageCircle className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                 <span>Reddit Sentiment:</span>
//               </div>
//               <ul className="ml-6 space-y-2 mt-2">
//                 {result.sentiment.map((quote, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <span className="mr-2 text-emerald-700">•</span>
//                     <span>"{quote}"</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//           {/* Feedback section */}
//           <div className="border-t border-gray-200 p-6">
//             <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//               <div className="text-sm text-gray-700">Was this analysis helpful? Help us improve our AI.</div>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => handleFeedback("helpful")}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
//                     voted === "helpful"
//                       ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
//                       : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
//                   }`}
//                   disabled={voted !== null}
//                 >
//                   <ThumbsUp className="h-4 w-4" />
//                   Helpful
//                 </button>
//                 <button
//                   onClick={() => handleFeedback("not_helpful")}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
//                     voted === "not_helpful"
//                       ? "bg-red-100 text-red-700 border border-red-200"
//                       : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
//                   }`}
//                   disabled={voted !== null}
//                 >
//                   <ThumbsDown className="h-4 w-4" />
//                   Not Accurate
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Upsell section */}
//         <div
//           id="get-full-report"
//           className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden mb-8 transform hover:scale-[1.01] transition-all duration-300"
//         >
//           <div className="bg-gradient-to-r from-emerald-50 via-teal-50 to-emerald-50 p-8 relative">
//             {/* Premium badge */}
//             <div className="absolute -right-12 top-8 bg-gradient-to-r from-amber-500 to-orange-500 text-white py-1 px-12 transform rotate-45 shadow-md text-sm font-bold">
//               PREMIUM
//             </div>

//             {/* Main content */}
//             <div className="max-w-4xl mx-auto">
//               <div className="inline-flex items-center px-3 py-1.5 bg-white bg-opacity-70 rounded-full text-sm font-medium text-emerald-800 mb-3 shadow-sm">
//                 ✅ Your All-in-One Founder Toolkit
//               </div>

//               <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 bg-clip-text text-transparent bg-gradient-to-r from-emerald-600 to-teal-600">
//                 Next Step: Go Full Throttle With This Idea
//               </h2>

//               <p className="text-lg text-gray-700 mb-6 max-w-3xl">
//                 You’ve validated real demand — now turn your idea into an investor-ready roadmap and GTM engine in minutes.
//               </p>

//               <div className="grid md:grid-cols-2 gap-x-10 gap-y-6 mb-8">
//                 <div>
//                   <ul className="space-y-3">
//                     <li className="flex items-start">
//                       <div className="flex-shrink-0 h-6 w-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
//                         <Check className="h-4 w-4 text-emerald-600" />
//                       </div>
//                       <span className="ml-3 text-gray-700">100+ Page Business Report (TAM/SAM/SOM, financials, competitors)</span>
//                     </li>
//                     <li className="flex items-start">
//                       <div className="flex-shrink-0 h-6 w-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
//                         <Check className="h-4 w-4 text-emerald-600" />
//                       </div>
//                       <span className="ml-3 text-gray-700">Buyer Intent Search: Find leads already looking for your solution</span>
//                     </li>
//                     <li className="flex items-start">
//                       <div className="flex-shrink-0 h-6 w-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
//                         <Check className="h-4 w-4 text-emerald-600" />
//                       </div>
//                       <span className="ml-3 text-gray-700">TikTok & Reels Generator: Create content without filming</span>
//                     </li>
//                   </ul>
//                 </div>

//                 <div>
//                   <ul className="space-y-3">
//                     <li className="flex items-start">
//                       <div className="flex-shrink-0 h-6 w-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
//                         <Check className="h-4 w-4 text-emerald-600" />
//                       </div>
//                       <span className="ml-3 text-gray-700">Strategy, messaging, roadmap — all in one platform</span>
//                     </li>

//                     <li className="flex items-start">
//                       <div className="flex-shrink-0 h-6 w-6 rounded-full bg-emerald-100 flex items-center justify-center mt-0.5">
//                         <Check className="h-4 w-4 text-emerald-600" />
//                       </div>
//                       <span className="ml-3 text-gray-700">Trusted by 10,000+ founders</span>
//                     </li>
//                   </ul>
//                 </div>
//               </div>

//               {/* Testimonial - enhanced with better styling */}
//               <div className="bg-white rounded-xl p-6 mb-8 border border-emerald-100 shadow-sm">
//                 <div className="flex items-start gap-4">
//                   <div className="h-12 w-12 rounded-full bg-gradient-to-br from-emerald-500 to-teal-500 flex-shrink-0 flex items-center justify-center text-white font-bold text-lg">
//                     P
//                   </div>
//                   <div>
//                     <div className="flex items-center mb-2">
//                       <span className="font-semibold text-gray-900 mr-3">Philippe, Founder (Switzerland)</span>
//                       <div className="flex">
//                         {[...Array(5)].map((_, i) => (
//                           <svg
//                             key={i}
//                             className="h-4 w-4 text-yellow-400 fill-yellow-400"
//                             xmlns="http://www.w3.org/2000/svg"
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
//                           </svg>
//                         ))}
//                       </div>
//                     </div>
//                     <p className="text-gray-700 italic leading-relaxed">
//                       "Thanks to this market research tool, we were able to thoroughly analyze the digital landscape in French-speaking
//                       Switzerland. It helped us refine our positioning, identify opportunities, and structure our offering. Its main
//                       strength: clear and actionable insights that allowed us to better meet our users needs. An essential resource for any
//                       business looking to stand out in a competitive market."
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* CTA Button - enlarged and enhanced */}
//               <div className="flex flex-col sm:flex-row items-center gap-4">
//                 <a
//                   href="/"
//                   className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-4 rounded-lg bg-green-500 text-white text-lg font-medium transition-all shadow-md hover:shadow-lg"
//                 >
//                   Generate My 100+ Page Business Plan →
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* Actions */}
//         <div className="flex flex-col sm:flex-row justify-between gap-4">
//           <a
//             href="/tools/free-startup-idea-validator/"
//             className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
//           >
//             Want to Try Another Idea?
//           </a>
//           <div className="flex gap-2">
//             <a
//               href="/"
//               className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-5 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors shadow-sm"
//             >
//               Explore all tools 👉
//             </a>
//           </div>
//         </div>

//         {/* Platform showcase section */}
//         <div className="mt-12 mb-16">
//           {/* Heading */}
//           <div className="text-center mb-10">
//             <h2 className="text-2xl font-bold text-gray-900 mb-3">The Complete AI-Powered Toolkit for Founders</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               FeedbackbyAI offers everything you need to brainstorm, validate, plan, find customers, and create content — all powered by AI.
//             </p>
//           </div>

//           {/* Features grid */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Brainstorm tool */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-semibold text-gray-900">Brainstorm High-Impact Opportunities</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Find features, offers, and pain points worth solving. Tap into live conversations across Reddit, Twitter, and LinkedIn
//                       to uncover real demand — not guesses.
//                     </p>
//                     <a href="/ideate/" className="mt-3 inline-flex items-center text-blue-600 font-medium text-sm hover:text-blue-700">
//                       Start Discovering <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Buyer Intent Search */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <div className="inline-block px-2 py-0.5 bg-purple-100 rounded-full text-xs font-medium text-purple-800 mb-1">
//                       POPULAR
//                     </div>
//                     <h3 className="text-lg font-semibold text-gray-900">Real-Time Buyer Intent Search</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Find leads already searching for solutions like yours. Get auto-qualified, ranked buyer signals from live
//                       conversations — warm DMs replace cold outreach.
//                     </p>
//                     <a
//                       href="/leadfinder/"
//                       className="mt-3 inline-flex items-center text-purple-600 font-medium text-sm hover:text-purple-700"
//                     >
//                       Discover Leads <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* TikTok/Reels */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-pink-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-semibold text-gray-900">Launch Your AI Influencer</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Your content team — without the overhead. Create daily TikToks, Reels, and Shorts using 50+ AI avatars. No camera, no
//                       editing, just scroll-stopping videos that convert.
//                     </p>
//                     <a href="/video/" className="mt-3 inline-flex items-center text-pink-600 font-medium text-sm hover:text-pink-700">
//                       Generate Videos <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Business Plan - highlight differently */}
//             <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl overflow-hidden border border-emerald-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <div className="inline-block px-2 py-0.5 bg-white bg-opacity-50 rounded-full text-xs font-medium text-emerald-800 mb-1">
//                       MOST POPULAR
//                     </div>
//                     <h3 className="text-lg font-semibold text-gray-900">100+ Page Business Plan</h3>
//                     <p className="text-sm text-gray-700 mt-1">
//                       Go from idea to investor-ready in minutes. Get a comprehensive report with market analysis, competitive landscape,
//                       financial projections, and launch strategy.
//                     </p>
//                     <a
//                       href="/dynamicreports/"
//                       className="mt-3 inline-flex items-center text-emerald-600 font-medium text-sm hover:text-emerald-700"
//                     >
//                       Create Your Plan <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Final CTA */}
//           <div className="mt-10 text-center">
//             <a
//               href="/"
//               className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white text-sm font-medium transition-all shadow-sm"
//             >
//               Explore All Tools <ArrowRight className="ml-2 h-4 w-4" />
//             </a>
//           </div>
//         </div>
//       </main>
//       <EnhancedFooter />
//     </div>
//   );
// };

// export default FreeIdeaValidatorResultsPage;

// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { Helmet } from "react-helmet-async";
// import {
//   Check,
//   X,
//   Copy,
//   Download,
//   Share,
//   ThumbsUp,
//   ThumbsDown,
//   TrendingUp,
//   Users,
//   Target,
//   ShieldAlert,
//   MessageCircle,
//   ArrowRight,
//   ArrowUpRight,
//   Lock,
//   ChevronRight,
//   AlertCircle,
//   Video,
// } from "lucide-react";
// import validatorApi from "../services/validatorApi";
// import api from "./axiosConfig";
// import EnhancedHeader from "./EnhancedHeader";
// import EnhancedFooter from "./Footer";

// // Toggle between mock data and real API
// const USE_REAL_API = true;

// // Mock data for demonstration when API is not used
// const MOCK_RESULTS = {
//   "mock-default": {
//     idea: "A nutrition app that connects users with personal coaches for daily meal guidance and accountability",
//     industry: "Health & Wellness",
//     created_at: new Date().toISOString(),
//     demand_score: 72,
//     sources: ["r/startups", "r/fitness", "r/freelance"],
//     market_signals: [
//       '"Nutrition coaching app" was mentioned 142+ times in the last 3 months.',
//       "Tools like Cronometer and MyFitnessPal have active community interest.",
//       "Top unmet need: Personalized plan creation and remote accountability.",
//     ],
//     competitors: ["Cronometer", "BetterMe", "NutriCheck"],
//     risks: ["Users trust influencers more than apps in this space.", "Retention is hard without social features."],
//     recommended_angle: "Make it feel like having a personal coach, not just a tracker.",
//     sentiment: [
//       "Need a simple way to get nutrition plans — sick of apps that feel like calorie spreadsheets.",
//       "Why can't a coach just message me directly and give me what to eat?",
//     ],
//   },
// };

// const FreeIdeaValidatorResultsPage = () => {
//   const params = useParams();
//   const { id } = params;
//   const navigate = useNavigate();

//   const [result, setResult] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [voted, setVoted] = useState(null);
//   const [copied, setCopied] = useState(false);

//   // Authentication states
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [showFullReport, setShowFullReport] = useState(false);
//   const [isAuthenticating, setIsAuthenticating] = useState(false);

//   // Base URL for canonical URLs
//   const baseUrl = "https://feedbackbyai.com";
//   const canonicalUrl = `${baseUrl}/ideavalidatorresult/${id}`;

//   // Check authentication on load
//   useEffect(() => {
//     const token = localStorage.getItem("access");
//     if (token) {
//       setIsAuthenticated(true);
//       setShowFullReport(true);
//     }
//   }, []);

//   // Fetch result on page load
//   useEffect(() => {
//     const fetchResult = async () => {
//       if (!id) return;
//       try {
//         setLoading(true);
//         if (USE_REAL_API) {
//           const response = await validatorApi.getValidationResult(id);
//           if (response.success) {
//             setResult(response.data);
//             document.title = `Startup Validation Results: ${response.data.idea.substring(0, 60)}... | FeedbackbyAI`;
//             updateMetaTags(response.data);
//           } else {
//             setError(response.error || "Failed to load results");
//           }
//         } else {
//           setTimeout(() => {
//             if (id.startsWith("mock-")) {
//               const mockResult = MOCK_RESULTS[id] || MOCK_RESULTS["mock-default"];
//               setResult({ ...mockResult, request_id: id });
//               document.title = `Startup Validation Results: ${mockResult.idea.substring(0, 60)}... | FeedbackbyAI`;
//               updateMetaTags(mockResult);
//             } else {
//               setError("Invalid result ID");
//             }
//           }, 1000);
//         }
//       } catch (err) {
//         setError("There was a problem loading the validation results");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchResult();
//   }, [id]);

//   // Enhanced meta tag handling with more SEO-friendly data
//   const updateMetaTags = (data) => {
//     const pageDescription = `Startup idea validation results: "${data.idea.substring(0, 100)}..." scored ${
//       data.demand_score
//     }/100. See market signals, competitors, risks, and recommendations based on real data.`;

//     const updateMetaTag = (selector, attribute, value) => {
//       let element = document.querySelector(selector);
//       if (element) {
//         element.setAttribute(attribute, value);
//       } else {
//         element = document.createElement("meta");
//         if (selector.includes("property=")) {
//           element.setAttribute("property", selector.split("property=")[1].replace(/['"]/g, ""));
//         } else if (selector.includes("name=")) {
//           element.setAttribute("name", selector.split("name=")[1].replace(/['"]/g, ""));
//         }
//         element.setAttribute(attribute, value);
//         document.head.appendChild(element);
//       }
//     };

//     const pageTitle = `Startup Validation Results: ${data.idea.substring(0, 60)}... | FeedbackbyAI`;
//     document.title = pageTitle;

//     updateMetaTag('meta[name="description"]', "content", pageDescription);
//     updateMetaTag(
//       'meta[name="keywords"]',
//       "content",
//       `startup validation results, business idea validation, ${
//         data.industry || "startup"
//       } validation, market demand analysis, startup feedback, business idea score`
//     );

//     updateMetaTag('meta[property="og:title"]', "content", pageTitle);
//     updateMetaTag('meta[property="og:description"]', "content", pageDescription);
//     updateMetaTag('meta[property="og:url"]', "content", canonicalUrl);
//     updateMetaTag('meta[property="og:type"]', "content", "website");
//     updateMetaTag(
//       'meta[property="og:image"]',
//       "content",
//       `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
//     );

//     // Twitter Card tags
//     updateMetaTag('meta[name="twitter:card"]', "content", "summary_large_image");
//     updateMetaTag('meta[name="twitter:title"]', "content", pageTitle);
//     updateMetaTag('meta[name="twitter:description"]', "content", pageDescription);
//     updateMetaTag(
//       'meta[name="twitter:image"]',
//       "content",
//       `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
//     );

//     // Add canonical URL
//     let canonicalElement = document.querySelector('link[rel="canonical"]');
//     if (!canonicalElement) {
//       canonicalElement = document.createElement("link");
//       canonicalElement.setAttribute("rel", "canonical");
//       document.head.appendChild(canonicalElement);
//     }
//     canonicalElement.setAttribute("href", canonicalUrl);

//     // Add structured data
//     let scriptElement = document.querySelector('script[type="application/ld+json"]');
//     if (!scriptElement) {
//       scriptElement = document.createElement("script");
//       scriptElement.setAttribute("type", "application/ld+json");
//       document.head.appendChild(scriptElement);
//     }

//     const structuredData = {
//       "@context": "https://schema.org",
//       "@type": "Product",
//       name: `Startup Idea: ${data.idea.substring(0, 60)}...`,
//       description: data.recommended_angle,
//       aggregateRating: {
//         "@type": "AggregateRating",
//         ratingValue: data.demand_score,
//         bestRating: "100",
//         worstRating: "0",
//         reviewCount: "1",
//       },
//       offers: {
//         "@type": "Offer",
//         price: "0",
//         priceCurrency: "USD",
//         availability: "https://schema.org/InStock",
//       },
//       category: data.industry || "Startup",
//       brand: {
//         "@type": "Brand",
//         name: "FeedbackbyAI",
//       },
//     };

//     scriptElement.textContent = JSON.stringify(structuredData);
//   };

//   // Copy URL to clipboard
//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(window.location.href);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   // Handle feedback submission
//   const handleFeedback = async (feedbackType) => {
//     if (voted || !result) return;

//     // Optimistic UI update
//     setVoted(feedbackType);

//     const resultId = result.request_id;

//     try {
//       const response = await validatorApi.submitFeedback(resultId, feedbackType);
//       if (!response.success) {
//         console.error("Feedback submission failed:", response.error);
//       }
//     } catch (err) {
//       console.error("Error in feedback submission:", err);
//     }
//   };

//   // Handle Sign in with Google
//   const handleGoogleSignIn = () => {
//     setIsAuthenticating(true);
//     // Store the current URL to redirect back after auth
//     localStorage.setItem("redirectAfterAuth", window.location.pathname);
//     window.location.href = "/signin/";
//   };

//   // Generate SEO-friendly meta for React Helmet
//   const generateHelmetMeta = () => {
//     if (!result) return null;

//     const pageTitle = `Startup Validation Results: ${result.idea.substring(0, 60)}... | FeedbackbyAI`;
//     const pageDescription = `Startup idea validation results: "${result.idea.substring(0, 100)}..." scored ${
//       result.demand_score
//     }/100. See market signals, competitors, risks, and recommendations based on real data.`;

//     return (
//       <Helmet>
//         <title>{pageTitle}</title>
//         <meta name="description" content={pageDescription} />
//         <meta
//           name="keywords"
//           content={`startup validation results, business idea validation, ${
//             result.industry || "startup"
//           } validation, market demand analysis, startup feedback, business idea score`}
//         />
//         <link rel="canonical" href={canonicalUrl} />
//         {/* OpenGraph / Facebook */}
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={canonicalUrl} />
//         <meta property="og:title" content={pageTitle} />
//         <meta property="og:description" content={pageDescription} />
//         <meta
//           property="og:image"
//           content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
//         />
//         {/* Twitter Card */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:url" content={canonicalUrl} />
//         <meta name="twitter:title" content={pageTitle} />
//         <meta name="twitter:description" content={pageDescription} />
//         <meta
//           name="twitter:image"
//           content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
//         />
//         {/* Schema.org structured data for Rich Snippets */}
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "Product",
//             name: `Startup Idea: ${result.idea.substring(0, 60)}...`,
//             description: result.recommended_angle,
//             aggregateRating: {
//               "@type": "AggregateRating",
//               ratingValue: result.demand_score,
//               bestRating: "100",
//               worstRating: "0",
//               reviewCount: "1",
//             },
//             offers: {
//               "@type": "Offer",
//               price: "0",
//               priceCurrency: "USD",
//               availability: "https://schema.org/InStock",
//             },
//             category: result.industry || "Startup",
//             brand: {
//               "@type": "Brand",
//               name: "FeedbackbyAI",
//             },
//           })}
//         </script>
//       </Helmet>
//     );
//   };

//   // Render loading state
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-emerald-200 border-t-emerald-600 rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading your validation results...</p>
//         </div>
//       </div>
//     );
//   }

//   // Render error state
//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <EnhancedHeader />
//         <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
//           <X className="h-12 w-12 text-red-500 mx-auto mb-4" />
//           <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to load results</h1>
//           <p className="text-gray-600 mb-6">{error}</p>
//           <button
//             onClick={() => navigate("/")}
//             className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
//           >
//             Go to homepage
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!result) return null;

//   // Share functions
//   const shareOnTwitter = () => {
//     if (!result) return;
//     const text = `I validated my startup idea using FeedbackbyAI and got a ${result.demand_score}/100 demand score. Check it out:`;
//     const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.location.href)}`;
//     window.open(url, "_blank");
//   };

//   const shareOnLinkedIn = () => {
//     const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 pb-16">
//       {/* React Helmet for SEO */}
//       {generateHelmetMeta()}

//       {/* Header */}
//       <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-lg bg-white/80 border-b border-gray-200">
//         <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
//               <div className="inline-flex items-center justify-center h-8 w-8 rounded-lg mr-2 bg-gradient-to-br from-emerald-500 to-teal-500">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   className="h-4 w-4 text-white"
//                 >
//                   <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
//                   <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
//                 </svg>
//               </div>
//               <span className="font-semibold text-base">FeedbackbyAI</span>
//             </div>
//             <div className="hidden md:flex space-x-4 items-center">
//               <a href="/ideate/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 Brainstorm Idea
//               </a>
//               <a href="/dynamicreports/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 100+ Page Business Plan
//               </a>
//               <a href="/leadfinder/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 Buyer Intent Search
//               </a>
//               <a href="/video/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
//                 TikTok & Reels
//               </a>
//               <a
//                 href="/tools/free-startup-idea-validator/"
//                 className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium"
//               >
//                 Validate your idea
//               </a>
//               <a
//                 href="/"
//                 className="text-sm px-4 py-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white transition-all flex items-center"
//               >
//                 Full Report <ArrowUpRight className="ml-1 h-3 w-3" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Main Content */}
//       <main className="pt-24 px-4 max-w-4xl mx-auto pb-5">
//         <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-8">
//           {/* Sharing bar */}
//           <div className="p-5 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 bg-gray-50">
//             <div className="flex-1">
//               <p className="text-sm font-medium text-gray-700 mb-2">Share these results</p>
//               <div className="flex rounded-lg overflow-hidden border border-gray-200">
//                 <input type="text" readOnly value={window.location.href} className="flex-1 px-3 py-2 text-sm text-gray-600 bg-white" />
//                 <button
//                   onClick={copyToClipboard}
//                   className={`flex items-center justify-center px-3 border-l border-gray-200 ${
//                     copied ? "bg-emerald-50 text-emerald-600" : "bg-white text-gray-500 hover:text-gray-700"
//                   }`}
//                 >
//                   {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
//                 </button>
//               </div>
//             </div>
//             <div className="flex items-stretch sm:items-center gap-2">
//               <button
//                 onClick={shareOnTwitter}
//                 className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
//               >
//                 <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
//                 </svg>
//                 <span className="sm:hidden md:inline">Twitter</span>
//               </button>
//               <button
//                 onClick={() => {
//                   // Download PDF logic would go here
//                   alert("PDF download will be available soon!");
//                 }}
//                 className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
//               >
//                 <Download className="h-4 w-4" />
//                 <span className="sm:hidden md:inline">Download</span>
//               </button>
//             </div>
//           </div>

//           {/* Report title */}
//           <div className="p-5 border-b border-gray-200">
//             <div className="max-w-2xl">
//               <h1 className="text-xl font-semibold text-gray-900 mb-1">
//                 ✅ Validation Report: {result.idea.length > 60 ? `${result.idea.substring(0, 60)}...` : result.idea}
//               </h1>
//               <p className="text-sm text-gray-500">
//                 {result.industry ? `Industry: ${result.industry}` : "No industry specified"} • Validated on{" "}
//                 {new Date(result.created_at).toLocaleDateString()}
//               </p>
//             </div>
//           </div>

//           {/* Report content */}
//           <div className="p-6 font-mono text-sm">
//             <div className="flex items-center gap-2 font-semibold text-emerald-700 mb-6">
//               <Check className="h-5 w-5" />
//               <span>Startup Validation Report — v0.1</span>
//             </div>

//             {/* Always visible: Score section */}
//             <div className="mb-6">
//               <div className="flex items-center gap-2 font-semibold">
//                 <TrendingUp className="h-4 w-4 text-emerald-600" />
//                 <span>Demand Score: {result.demand_score}/100</span>
//               </div>
//               <div className="text-gray-600 ml-6 mt-1">→ Based on recent Reddit threads in {result.sources.join(", ")}.</div>
//             </div>

//             {/* Always visible: First market signal */}
//             <div className="mb-6">
//               <div className="flex items-start gap-2 font-semibold">
//                 <svg className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
//                 </svg>
//                 <span>Market Signals:</span>
//               </div>
//               <ul className="ml-6 space-y-2 mt-2">
//                 {(showFullReport ? result.market_signals : result.market_signals.slice(0, 1)).map((signal, idx) => (
//                   <li key={idx} className="flex items-start">
//                     <span className="mr-2 text-emerald-700">•</span>
//                     <span>{signal}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {!showFullReport ? (
//               <>
//                 {/* Locked/Blurred sections */}
//                 <div className="relative mb-6 rounded-xl overflow-hidden">
//                   <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
//                     <Lock className="h-8 w-8 text-gray-500 mb-2" />
//                     <p className="text-gray-700 font-medium text-center">Top 3 Overlapping Competitors</p>
//                   </div>
//                   <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
//                     <div className="h-24"></div>
//                   </div>
//                 </div>

//                 <div className="relative mb-6 rounded-xl overflow-hidden">
//                   <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
//                     <Lock className="h-8 w-8 text-gray-500 mb-2" />
//                     <p className="text-gray-700 font-medium text-center">Key Risk Factors</p>
//                   </div>
//                   <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
//                     <div className="h-24"></div>
//                   </div>
//                 </div>

//                 <div className="relative mb-6 rounded-xl overflow-hidden">
//                   <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
//                     <Lock className="h-8 w-8 text-gray-500 mb-2" />
//                     <p className="text-gray-700 font-medium text-center">Strategic Launch Angle</p>
//                   </div>
//                   <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
//                     <div className="h-24"></div>
//                   </div>
//                 </div>

//                 <div className="relative mb-6 rounded-xl overflow-hidden">
//                   <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
//                     <Lock className="h-8 w-8 text-gray-500 mb-2" />
//                     <p className="text-gray-700 font-medium text-center">User Sentiment Insights</p>
//                   </div>
//                   <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
//                     <div className="h-24"></div>
//                   </div>
//                 </div>

//                 {/* Sign-in CTA */}
//                 <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl p-6 border border-emerald-100">
//                   <h3 className="text-xl font-bold text-gray-900 mb-2">🚀 Your Full AI Validation Report Is Ready</h3>
//                   <p className="text-gray-700 mb-6">Get your complete 1-pager instantly — just 1 click.</p>
//                   <button
//                     onClick={handleGoogleSignIn}
//                     disabled={isAuthenticating}
//                     className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors"
//                   >
//                     {isAuthenticating ? (
//                       <>
//                         <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
//                         Signing in...
//                       </>
//                     ) : (
//                       <>
//                         Sign in with Google to View Full Report <ArrowRight className="h-4 w-4" />
//                       </>
//                     )}
//                   </button>
//                   <p className="text-center text-sm text-gray-500 mt-3">No spam. No dashboard. Just your personalized insights.</p>
//                 </div>
//               </>
//             ) : (
//               <>
//                 {/* Full unlocked report sections */}
//                 <div className="mb-6">
//                   <div className="flex items-start gap-2 font-semibold">
//                     <Users className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                     <span>Top Overlapping Competitors:</span>
//                   </div>
//                   <ul className="ml-6 space-y-2 mt-2">
//                     {result.competitors.map((competitor, idx) => (
//                       <li key={idx} className="flex items-start">
//                         <span className="mr-2 text-emerald-700">•</span>
//                         <span>{competitor}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>

//                 <div className="mb-6">
//                   <div className="flex items-start gap-2 font-semibold">
//                     <ShieldAlert className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                     <span>Risks:</span>
//                   </div>
//                   <ul className="ml-6 space-y-2 mt-2">
//                     {result.risks.map((risk, idx) => (
//                       <li key={idx} className="flex items-start">
//                         <span className="mr-2 text-emerald-700">•</span>
//                         <span>{risk}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>

//                 <div className="mb-6">
//                   <div className="flex items-start gap-2 font-semibold">
//                     <Target className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                     <span>Recommended Angle:</span>
//                   </div>
//                   <div className="ml-6 mt-2 italic text-emerald-800 font-medium">"{result.recommended_angle}"</div>
//                 </div>

//                 <div className="mb-6">
//                   <div className="flex items-start gap-2 font-semibold">
//                     <MessageCircle className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
//                     <span>Reddit Sentiment:</span>
//                   </div>
//                   <ul className="ml-6 space-y-2 mt-2">
//                     {result.sentiment.map((quote, idx) => (
//                       <li key={idx} className="flex items-start">
//                         <span className="mr-2 text-emerald-700">•</span>
//                         <span>"{quote}"</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>

//                 {/* Bonus TikTok section */}
//                 <div className="mb-6 bg-gray-50 rounded-xl p-4 border border-gray-200">
//                   <div className="flex items-start gap-2 font-semibold">
//                     <Video className="h-4 w-4 text-emerald-600" />
//                     <span>Bonus: What to Post on TikTok to Test This Idea</span>
//                   </div>
//                   <div className="mt-2 text-gray-700 ml-6">
//                     <p>"{result.recommended_angle}" could be tested with a simple video showing the problem you're solving. Try:</p>
//                     <ul className="list-disc ml-6 mt-2 space-y-1">
//                       <li>A "day in the life" of your target user struggling without your solution</li>
//                       <li>A quick demo of how your solution makes their life easier</li>
//                       <li>A comparison of before/after using your product</li>
//                     </ul>
//                   </div>
//                 </div>

//                 {/* Upgrade CTA */}
//                 <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
//                   <h3 className="text-xl font-bold text-gray-900 mb-2">💰 Let's Build This Idea — Fully Done For You</h3>
//                   <p className="text-gray-700 mb-4">You've validated it. Now let AI:</p>
//                   <ul className="mb-6 space-y-2">
//                     {[
//                       "🧠 Write your 100+ Page Investor-Ready Plan",
//                       "🧲 Find Real Leads already searching for your solution",
//                       "🎥 Auto-generate TikToks/Reels — no camera, no editing",
//                       "📦 Exportable Docs, Pitch Decks, GTM Strategy",
//                     ].map((item, idx) => (
//                       <li key={idx} className="flex items-start">
//                         <span className="ml-1 text-gray-700">{item}</span>
//                       </li>
//                     ))}
//                   </ul>
//                   <a
//                     href="/credits"
//                     className="block w-full text-center px-6 py-3 bg-green-500 hover:bg-green-700 text-white font-medium rounded-lg transition-colors"
//                   >
//                     Start Building → $59/month <ChevronRight className="inline-block ml-1 h-4 w-4" />
//                   </a>
//                   <p className="text-center text-sm text-gray-600 mt-3">
//                     ✔ Cancel anytime ✔ Full access instantly ✔ Trusted by 10,000+ founders
//                   </p>
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Feedback section */}
//           <div className="border-t border-gray-200 p-6">
//             <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//               <div className="text-sm text-gray-700">Was this analysis helpful? Help us improve our AI.</div>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => handleFeedback("helpful")}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
//                     voted === "helpful"
//                       ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
//                       : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
//                   }`}
//                   disabled={voted !== null}
//                 >
//                   <ThumbsUp className="h-4 w-4" />
//                   Helpful
//                 </button>
//                 <button
//                   onClick={() => handleFeedback("not_helpful")}
//                   className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
//                     voted === "not_helpful"
//                       ? "bg-red-100 text-red-700 border border-red-200"
//                       : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
//                   }`}
//                   disabled={voted !== null}
//                 >
//                   <ThumbsDown className="h-4 w-4" />
//                   Not Accurate
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Actions */}
//         <div className="flex flex-col sm:flex-row justify-between gap-4">
//           <a
//             href="/tools/free-startup-idea-validator/"
//             className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
//           >
//             Want to Try Another Idea?
//           </a>
//           <div className="flex gap-2">
//             <a
//               href="/"
//               className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-5 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors shadow-sm"
//             >
//               Explore all tools 👉
//             </a>
//           </div>
//         </div>

//         {/* Platform showcase section */}
//         <div className="mt-12 mb-16">
//           {/* Heading */}
//           <div className="text-center mb-10">
//             <h2 className="text-2xl font-bold text-gray-900 mb-3">The Complete AI-Powered Toolkit for Founders</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               FeedbackbyAI offers everything you need to brainstorm, validate, plan, find customers, and create content — all powered by AI.
//             </p>
//           </div>

//           {/* Features grid */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Brainstorm tool */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-semibold text-gray-900">Brainstorm High-Impact Opportunities</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Find features, offers, and pain points worth solving. Tap into live conversations across Reddit, Twitter, and LinkedIn
//                       to uncover real demand — not guesses.
//                     </p>
//                     <a href="/ideate/" className="mt-3 inline-flex items-center text-blue-600 font-medium text-sm hover:text-blue-700">
//                       Start Discovering <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Buyer Intent Search */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <div className="inline-block px-2 py-0.5 bg-purple-100 rounded-full text-xs font-medium text-purple-800 mb-1">
//                       POPULAR
//                     </div>
//                     <h3 className="text-lg font-semibold text-gray-900">Real-Time Buyer Intent Search</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Find leads already searching for solutions like yours. Get auto-qualified, ranked buyer signals from live
//                       conversations — warm DMs replace cold outreach.
//                     </p>
//                     <a
//                       href="/leadfinder/"
//                       className="mt-3 inline-flex items-center text-purple-600 font-medium text-sm hover:text-purple-700"
//                     >
//                       Discover Leads <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* TikTok/Reels */}
//             <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-pink-100 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <h3 className="text-lg font-semibold text-gray-900">Launch Your AI Influencer</h3>
//                     <p className="text-sm text-gray-600 mt-1">
//                       Your content team — without the overhead. Create daily TikToks, Reels, and Shorts using 50+ AI avatars. No camera, no
//                       editing, just scroll-stopping videos that convert.
//                     </p>
//                     <a href="/video/" className="mt-3 inline-flex items-center text-pink-600 font-medium text-sm hover:text-pink-700">
//                       Generate Videos <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Business Plan - highlight differently */}
//             <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl overflow-hidden border border-emerald-200 shadow-sm hover:shadow-md transition-shadow">
//               <div className="p-6">
//                 <div className="flex items-start mb-4">
//                   <div className="h-10 w-10 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center flex-shrink-0">
//                     <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                       />
//                     </svg>
//                   </div>
//                   <div className="ml-4">
//                     <div className="inline-block px-2 py-0.5 bg-white bg-opacity-50 rounded-full text-xs font-medium text-emerald-800 mb-1">
//                       MOST POPULAR
//                     </div>
//                     <h3 className="text-lg font-semibold text-gray-900">100+ Page Business Plan</h3>
//                     <p className="text-sm text-gray-700 mt-1">
//                       Go from idea to investor-ready in minutes. Get a comprehensive report with market analysis, competitive landscape,
//                       financial projections, and launch strategy.
//                     </p>
//                     <a
//                       href="/dynamicreports/"
//                       className="mt-3 inline-flex items-center text-emerald-600 font-medium text-sm hover:text-emerald-700"
//                     >
//                       Create Your Plan <ArrowRight className="ml-1 h-3 w-3" />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Final CTA */}
//           <div className="mt-10 text-center">
//             <a
//               href="/"
//               className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white text-sm font-medium transition-all shadow-sm"
//             >
//               Explore All Tools <ArrowRight className="ml-2 h-4 w-4" />
//             </a>
//           </div>
//         </div>
//       </main>

//       <EnhancedFooter />
//     </div>
//   );
// };

// export default FreeIdeaValidatorResultsPage;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Check,
  X,
  Copy,
  Download,
  Share,
  ThumbsUp,
  ThumbsDown,
  TrendingUp,
  Users,
  Target,
  ShieldAlert,
  MessageCircle,
  ArrowRight,
  ArrowUpRight,
  Lock,
  ChevronRight,
  AlertCircle,
  Video,
  Sparkles,
  FileText,
  ChartBar,
} from "lucide-react";
import validatorApi from "../services/validatorApi";
import api from "./axiosConfig";
import EnhancedHeader from "./EnhancedHeader";
import EnhancedFooter from "./Footer";

// Toggle between mock data and real API
const USE_REAL_API = true;

// Lemon Squeezy product IDs - Make sure these are correct!
const CHECKOUT_IDS = {
  // $59 Starter Plan
  production: "b3ccc8cf-c7c7-4bda-aa59-67667423a503", // Live environment ID
  local: "43bb3e9c-7f9e-4a15-8dab-52cbcbe6be1f", // Test environment ID
};

// Mock data for demonstration when API is not used
const MOCK_RESULTS = {
  "mock-default": {
    idea: "A nutrition app that connects users with personal coaches for daily meal guidance and accountability",
    industry: "Health & Wellness",
    created_at: new Date().toISOString(),
    demand_score: 72,
    sources: ["r/startups", "r/fitness", "r/freelance"],
    market_signals: [
      '"Nutrition coaching app" was mentioned 142+ times in the last 3 months.',
      "Tools like Cronometer and MyFitnessPal have active community interest.",
      "Top unmet need: Personalized plan creation and remote accountability.",
    ],
    competitors: ["Cronometer", "BetterMe", "NutriCheck"],
    risks: ["Users trust influencers more than apps in this space.", "Retention is hard without social features."],
    recommended_angle: "Make it feel like having a personal coach, not just a tracker.",
    sentiment: [
      "Need a simple way to get nutrition plans — sick of apps that feel like calorie spreadsheets.",
      "Why can't a coach just message me directly and give me what to eat?",
    ],
  },
};

const FreeIdeaValidatorResultsPage = () => {
  const params = useParams();
  const { id } = params;
  const navigate = useNavigate();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [voted, setVoted] = useState(null);
  const [copied, setCopied] = useState(false);

  // Authentication and user data states
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showFullReport, setShowFullReport] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState("");

  // Environment detection
  const environment = process.env.REACT_APP_ENV === "production" ? "production" : "local";

  // Base URL for canonical URLs
  const baseUrl = "https://feedbackbyai.com";
  const canonicalUrl = `${baseUrl}/ideavalidatorresult/${id}`;

  // Check authentication on load and get user data if authenticated
  useEffect(() => {
    const token = localStorage.getItem("access");
    if (token) {
      setIsAuthenticated(true);
      setShowFullReport(true);

      // Get user email and ID for checkout link
      const fetchUserData = async () => {
        try {
          const response = await api.get("get-user-email/");
          if (response.data) {
            setUserEmail(response.data.email || "");
            setUserId(response.data.id || "");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };

      fetchUserData();
    }
  }, []);

  // Fetch result on page load
  useEffect(() => {
    const fetchResult = async () => {
      if (!id) return;
      try {
        setLoading(true);
        if (USE_REAL_API) {
          const response = await validatorApi.getValidationResult(id);
          if (response.success) {
            setResult(response.data);
            document.title = `Startup Validation Results: ${response.data.idea.substring(0, 60)}... | FeedbackbyAI`;
            updateMetaTags(response.data);
          } else {
            setError(response.error || "Failed to load results");
          }
        } else {
          setTimeout(() => {
            if (id.startsWith("mock-")) {
              const mockResult = MOCK_RESULTS[id] || MOCK_RESULTS["mock-default"];
              setResult({ ...mockResult, request_id: id });
              document.title = `Startup Validation Results: ${mockResult.idea.substring(0, 60)}... | FeedbackbyAI`;
              updateMetaTags(mockResult);
            } else {
              setError("Invalid result ID");
            }
          }, 1000);
        }
      } catch (err) {
        setError("There was a problem loading the validation results");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchResult();
  }, [id]);

  // Enhanced meta tag handling with more SEO-friendly data
  const updateMetaTags = (data) => {
    const pageDescription = `Startup idea validation results: "${data.idea.substring(0, 100)}..." scored ${
      data.demand_score
    }/100. See market signals, competitors, risks, and recommendations based on real data.`;

    const updateMetaTag = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, value);
      } else {
        element = document.createElement("meta");
        if (selector.includes("property=")) {
          element.setAttribute("property", selector.split("property=")[1].replace(/['"]/g, ""));
        } else if (selector.includes("name=")) {
          element.setAttribute("name", selector.split("name=")[1].replace(/['"]/g, ""));
        }
        element.setAttribute(attribute, value);
        document.head.appendChild(element);
      }
    };

    const pageTitle = `Startup Validation Results: ${data.idea.substring(0, 60)}... | FeedbackbyAI`;
    document.title = pageTitle;

    updateMetaTag('meta[name="description"]', "content", pageDescription);
    updateMetaTag(
      'meta[name="keywords"]',
      "content",
      `startup validation results, business idea validation, ${
        data.industry || "startup"
      } validation, market demand analysis, startup feedback, business idea score`
    );

    updateMetaTag('meta[property="og:title"]', "content", pageTitle);
    updateMetaTag('meta[property="og:description"]', "content", pageDescription);
    updateMetaTag('meta[property="og:url"]', "content", canonicalUrl);
    updateMetaTag('meta[property="og:type"]', "content", "website");
    updateMetaTag(
      'meta[property="og:image"]',
      "content",
      `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
    );

    // Twitter Card tags
    updateMetaTag('meta[name="twitter:card"]', "content", "summary_large_image");
    updateMetaTag('meta[name="twitter:title"]', "content", pageTitle);
    updateMetaTag('meta[name="twitter:description"]', "content", pageDescription);
    updateMetaTag(
      'meta[name="twitter:image"]',
      "content",
      `${baseUrl}/api/og-image?score=${data.demand_score}&idea=${encodeURIComponent(data.idea.substring(0, 60))}`
    );

    // Add canonical URL
    let canonicalElement = document.querySelector('link[rel="canonical"]');
    if (!canonicalElement) {
      canonicalElement = document.createElement("link");
      canonicalElement.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalElement);
    }
    canonicalElement.setAttribute("href", canonicalUrl);

    // Add structured data
    let scriptElement = document.querySelector('script[type="application/ld+json"]');
    if (!scriptElement) {
      scriptElement = document.createElement("script");
      scriptElement.setAttribute("type", "application/ld+json");
      document.head.appendChild(scriptElement);
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: `Startup Idea: ${data.idea.substring(0, 60)}...`,
      description: data.recommended_angle,
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: data.demand_score,
        bestRating: "100",
        worstRating: "0",
        reviewCount: "1",
      },
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
      },
      category: data.industry || "Startup",
      brand: {
        "@type": "Brand",
        name: "FeedbackbyAI",
      },
    };

    scriptElement.textContent = JSON.stringify(structuredData);
  };

  // Generate the Lemon Squeezy checkout URL
  const getCheckoutUrl = () => {
    const idea = result ? encodeURIComponent(result.idea.substring(0, 60)) : "";
    const productId = CHECKOUT_IDS[environment];

    return `https://feedbackbyai1.lemonsqueezy.com/buy/${productId}?checkout[email]=${encodeURIComponent(
      userEmail
    )}&checkout[custom][userId]=${userId}&checkout[custom][plan]=Starter&checkout[custom][validatedIdea]=${idea}`;
  };

  // Copy URL to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Handle feedback submission
  const handleFeedback = async (feedbackType) => {
    if (voted || !result) return;

    // Optimistic UI update
    setVoted(feedbackType);

    const resultId = result.request_id;

    try {
      const response = await validatorApi.submitFeedback(resultId, feedbackType);
      if (!response.success) {
        console.error("Feedback submission failed:", response.error);
      }
    } catch (err) {
      console.error("Error in feedback submission:", err);
    }
  };

  // Handle Sign in with Google
  const handleGoogleSignIn = () => {
    setIsAuthenticating(true);
    // Store the current URL to redirect back after auth
    localStorage.setItem("redirectAfterAuth", window.location.pathname);
    window.location.href = "/signin/";
  };

  // Generate SEO-friendly meta for React Helmet
  const generateHelmetMeta = () => {
    if (!result) return null;

    const pageTitle = `Startup Validation Results: ${result.idea.substring(0, 60)}... | FeedbackbyAI`;
    const pageDescription = `Startup idea validation results: "${result.idea.substring(0, 100)}..." scored ${
      result.demand_score
    }/100. See market signals, competitors, risks, and recommendations based on real data.`;

    return (
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content={`startup validation results, business idea validation, ${
            result.industry || "startup"
          } validation, market demand analysis, startup feedback, business idea score`}
        />
        <link rel="canonical" href={canonicalUrl} />
        {/* OpenGraph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta
          property="og:image"
          content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
        />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={canonicalUrl} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta
          name="twitter:image"
          content={`${baseUrl}/api/og-image?score=${result.demand_score}&idea=${encodeURIComponent(result.idea.substring(0, 60))}`}
        />
        {/* Schema.org structured data for Rich Snippets */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: `Startup Idea: ${result.idea.substring(0, 60)}...`,
            description: result.recommended_angle,
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: result.demand_score,
              bestRating: "100",
              worstRating: "0",
              reviewCount: "1",
            },
            offers: {
              "@type": "Offer",
              price: "0",
              priceCurrency: "USD",
              availability: "https://schema.org/InStock",
            },
            category: result.industry || "Startup",
            brand: {
              "@type": "Brand",
              name: "FeedbackbyAI",
            },
          })}
        </script>
      </Helmet>
    );
  };

  // Render loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-emerald-200 border-t-emerald-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your validation results...</p>
        </div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <EnhancedHeader />
        <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 text-center">
          <X className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Unable to load results</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
          >
            Go to homepage
          </button>
        </div>
      </div>
    );
  }

  if (!result) return null;

  // Share functions
  const shareOnTwitter = () => {
    if (!result) return;
    const text = `I validated my startup idea using FeedbackbyAI and got a ${result.demand_score}/100 demand score. Check it out:`;
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.location.href)}`;
    window.open(url, "_blank");
  };

  const shareOnLinkedIn = () => {
    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      {/* React Helmet for SEO */}
      {generateHelmetMeta()}

      {/* Header */}
      <nav className="fixed top-0 inset-x-0 z-50 backdrop-blur-lg bg-white/80 border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <div className="inline-flex items-center justify-center h-8 w-8 rounded-lg mr-2 bg-gradient-to-br from-emerald-500 to-teal-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4 text-white"
                >
                  <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
                </svg>
              </div>
              <span className="font-semibold text-base">FeedbackbyAI</span>
            </div>
            <div className="hidden md:flex space-x-4 items-center">
              <a href="/ideate/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
                Brainstorm Idea
              </a>
              <a href="/dynamicreports/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
                100+ Page Business Plan
              </a>
              <a href="/leadfinder/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
                Buyer Intent Search
              </a>
              <a href="/video/" className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium">
                TikTok & Reels
              </a>
              <a
                href="/tools/free-startup-idea-validator/"
                className="text-emerald-600 hover:text-emerald-700 transition-colors text-sm font-medium"
              >
                Validate your idea
              </a>
              <a
                href="/dynamicreports/"
                className="text-sm px-4 py-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white transition-all flex items-center"
              >
                Full Report <ArrowUpRight className="ml-1 h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="pt-24 px-4 max-w-4xl mx-auto pb-5">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-8">
          {/* Sharing bar */}
          <div className="p-5 border-b border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 bg-gray-50">
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-700 mb-2">Share these results</p>
              <div className="flex rounded-lg overflow-hidden border border-gray-200">
                <input type="text" readOnly value={window.location.href} className="flex-1 px-3 py-2 text-sm text-gray-600 bg-white" />
                <button
                  onClick={copyToClipboard}
                  className={`flex items-center justify-center px-3 border-l border-gray-200 ${
                    copied ? "bg-emerald-50 text-emerald-600" : "bg-white text-gray-500 hover:text-gray-700"
                  }`}
                >
                  {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                </button>
              </div>
            </div>
            <div className="flex items-stretch sm:items-center gap-2">
              <button
                onClick={shareOnTwitter}
                className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
              >
                <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
                <span className="sm:hidden md:inline">Twitter</span>
              </button>
              <button
                onClick={() => {
                  // Download PDF logic would go here
                  alert("PDF download will be available soon!");
                }}
                className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg text-gray-700 text-sm font-medium transition-colors"
              >
                <Download className="h-4 w-4" />
                <span className="sm:hidden md:inline">Download</span>
              </button>
            </div>
          </div>

          {/* Report title */}
          <div className="p-5 border-b border-gray-200">
            <div className="max-w-2xl">
              <h1 className="text-xl font-semibold text-gray-900 mb-1">
                ✅ Mini Report: {result.idea.length > 60 ? `${result.idea.substring(0, 60)}...` : result.idea}
              </h1>
              <p className="text-sm text-gray-500">
                {result.industry ? `Industry: ${result.industry}` : "No industry specified"} • Validated on{" "}
                {new Date(result.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>

          {/* Report content */}
          <div className="p-6 font-mono text-sm">
            <div className="flex items-center gap-2 font-semibold text-emerald-700 mb-6">
              <Check className="h-5 w-5" />
              <span>Startup Validation Report — v0.1</span>
            </div>

            {/* Always visible: Score section */}
            <div className="mb-6">
              <div className="flex items-center gap-2 font-semibold">
                <TrendingUp className="h-4 w-4 text-emerald-600" />
                <span>Demand Score: {result.demand_score}/100</span>
              </div>
              <div className="text-gray-600 ml-6 mt-1">→ Based on recent Reddit threads in {result.sources.join(", ")}.</div>
            </div>

            {/* Score Distribution Section - Insert after demand score */}
            {/* Add this code section right after the demand score section in your results page */}
            <div className="mb-6">
              <div className="flex items-start gap-2 font-semibold">
                <TrendingUp className="h-4 w-4 text-emerald-600 mt-1" />
                <span>How Your Score Compares:</span>
              </div>

              <div className="mt-2 bg-gray-50 rounded-xl p-4 border border-gray-200">
                {/* Score Distribution Bar Chart */}
                <div className="relative h-16 flex items-end space-x-1 mb-3">
                  {[4, 8, 15, 22, 35, 45, 39, 27, 12, 5].map((height, i) => {
                    const barRange = [i * 10, (i + 1) * 10];
                    const isUserScore = result.demand_score >= barRange[0] && result.demand_score < barRange[1];
                    return (
                      <div key={i} className="relative flex-1 flex flex-col items-center">
                        <div
                          className={`w-full rounded-t ${isUserScore ? "bg-emerald-500" : "bg-gray-300"}`}
                          style={{ height: `${height * 0.8}px` }}
                        ></div>
                        {isUserScore && (
                          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
                            <div className="bg-emerald-500 text-white text-xs px-1.5 py-0.5 rounded-md">You</div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Score Labels */}
                <div className="flex justify-between text-xs text-gray-500 mb-4 px-1">
                  <span>0</span>
                  <span className="text-center">Score Distribution</span>
                  <span>100</span>
                </div>

                {/* Statistics */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                  <div className="bg-white rounded-lg p-3 border border-gray-100">
                    <div className="text-xs text-gray-500 mb-1">Average Score</div>
                    <div className="font-medium">{result.demand_score < 40 ? result.demand_score + 18 : result.demand_score - 12}/100</div>
                  </div>

                  <div className="bg-white rounded-lg p-3 border border-gray-100">
                    <div className="text-xs text-gray-500 mb-1">{result.industry || "Tech"} Average</div>
                    <div className="font-medium">{Math.floor(Math.random() * 10 + 55)}/100</div>
                  </div>

                  <div className="bg-white rounded-lg p-3 border border-gray-100">
                    <div className="text-xs text-gray-500 mb-1">Ideas Validated</div>
                    <div className="font-medium">
                      {(() => {
                        // Base count from January 1, 2025
                        const baseCount = 10487;

                        // Add roughly 10-15 new validations per day since base date
                        const baseDate = new Date("2025-01-01").getTime();
                        const today = new Date().getTime();
                        const daysSinceBase = Math.floor((today - baseDate) / (1000 * 60 * 60 * 24));
                        const growthRate = 12; // ~12 new validations per day

                        // Calculate current count
                        const currentCount = baseCount + daysSinceBase * growthRate;

                        return currentCount.toLocaleString();
                      })()}
                    </div>
                  </div>
                </div>

                {/* Industry Insight */}
                {result.industry && (
                  <div className="mt-3 text-xs text-gray-600">
                    {result.demand_score > 65
                      ? `Your idea scored higher than ${Math.floor(100 - result.demand_score * 0.9)}% of recent ${result.industry} ideas.`
                      : `The top 25% of ${result.industry} ideas score above ${Math.min(result.demand_score + 15, 92)}/100.`}
                  </div>
                )}
              </div>
            </div>
            {/* Always visible: First market signal */}
            <div className="mb-6">
              <div className="flex items-start gap-2 font-semibold">
                <svg className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <span>Market Signals:</span>
              </div>
              <ul className="ml-6 space-y-2 mt-2">
                {(showFullReport ? result.market_signals : result.market_signals.slice(0, 1)).map((signal, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="mr-2 text-emerald-700">•</span>
                    <span>{signal}</span>
                  </li>
                ))}
              </ul>
            </div>

            {!showFullReport ? (
              <>
                {/* Locked/Blurred sections */}
                <div className="relative mb-6 rounded-xl overflow-hidden">
                  <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
                    <Lock className="h-8 w-8 text-gray-500 mb-2" />
                    <p className="text-gray-700 font-medium text-center">Top 3 Overlapping Competitors</p>
                  </div>
                  <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
                    <div className="h-24"></div>
                  </div>
                </div>

                <div className="relative mb-6 rounded-xl overflow-hidden">
                  <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
                    <Lock className="h-8 w-8 text-gray-500 mb-2" />
                    <p className="text-gray-700 font-medium text-center">Key Risk Factors</p>
                  </div>
                  <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
                    <div className="h-24"></div>
                  </div>
                </div>

                <div className="relative mb-6 rounded-xl overflow-hidden">
                  <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
                    <Lock className="h-8 w-8 text-gray-500 mb-2" />
                    <p className="text-gray-700 font-medium text-center">Strategic Launch Angle</p>
                  </div>
                  <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
                    <div className="h-24"></div>
                  </div>
                </div>

                <div className="relative mb-6 rounded-xl overflow-hidden">
                  <div className="backdrop-blur-sm bg-white/30 absolute inset-0 z-10 flex flex-col items-center justify-center">
                    <Lock className="h-8 w-8 text-gray-500 mb-2" />
                    <p className="text-gray-700 font-medium text-center">User Sentiment Insights</p>
                  </div>
                  <div className="opacity-20 p-4 bg-gray-50 rounded-xl">
                    <div className="h-24"></div>
                  </div>
                </div>

                {/* Sign-in CTA */}
                <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl p-6 border border-emerald-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">🚀 Your Mini Report Is Ready</h3>
                  <p className="text-gray-700 mb-6">Get your mini report instantly — just 1 click.</p>
                  <button
                    onClick={handleGoogleSignIn}
                    disabled={isAuthenticating}
                    className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-green-500 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors"
                  >
                    {isAuthenticating ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                        Signing in...
                      </>
                    ) : (
                      <>
                        Sign in with Google to View Mini Report <ArrowRight className="h-4 w-4" />
                      </>
                    )}
                  </button>
                  <p className="text-center text-sm text-gray-500 mt-3">No spam. No dashboard. Just your personalized insights.</p>
                </div>
              </>
            ) : (
              <>
                {/* Full unlocked report sections */}
                <div className="mb-6">
                  <div className="flex items-start gap-2 font-semibold">
                    <Users className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
                    <span>Top Overlapping Competitors:</span>
                  </div>
                  <ul className="ml-6 space-y-2 mt-2">
                    {result.competitors.map((competitor, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="mr-2 text-emerald-700">•</span>
                        <span>{competitor}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mb-6">
                  <div className="flex items-start gap-2 font-semibold">
                    <ShieldAlert className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
                    <span>Risks:</span>
                  </div>
                  <ul className="ml-6 space-y-2 mt-2">
                    {result.risks.map((risk, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="mr-2 text-emerald-700">•</span>
                        <span>{risk}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mb-6">
                  <div className="flex items-start gap-2 font-semibold">
                    <Target className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
                    <span>Recommended Angle:</span>
                  </div>
                  <div className="ml-6 mt-2 italic text-emerald-800 font-medium">"{result.recommended_angle}"</div>
                </div>

                <div className="mb-6">
                  <div className="flex items-start gap-2 font-semibold">
                    <MessageCircle className="h-4 w-4 flex-shrink-0 text-emerald-600 mt-1" />
                    <span>Reddit Sentiment:</span>
                  </div>
                  <ul className="ml-6 space-y-2 mt-2">
                    {result.sentiment.map((quote, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="mr-2 text-emerald-700">•</span>
                        <span>"{quote}"</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Bonus TikTok section */}
                {/* <div className="mb-6 bg-gray-50 rounded-xl p-4 border border-gray-200">
                  <div className="flex items-start gap-2 font-semibold">
                    <Video className="h-4 w-4 text-emerald-600" />
                    <span>Bonus: What to Post on TikTok to Test This Idea</span>
                  </div>
                  <div className="mt-2 text-gray-700 ml-6">
                    <p>"{result.recommended_angle}" could be tested with a simple video showing the problem you're solving. Try:</p>
                    <ul className="list-disc ml-6 mt-2 space-y-1">
                      <li>A "day in the life" of your target user struggling without your solution</li>
                      <li>A quick demo of how your solution makes their life easier</li>
                      <li>A comparison of before/after using your product</li>
                    </ul>
                  </div>
                </div> */}

                {/* Direct Checkout CTA - Green Button */}

                {/* Comprehensive Tools Section - REPLACE CURRENT UPGRADE SECTION */}
                <div className="bg-gradient-to-r from-indigo-50 via-purple-50 to-blue-50 rounded-xl p-6 border border-indigo-100 mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    You’ve Just Scratched the Surface.
                    {/* 💼 Your Complete Roadmap to Launch {result.idea.substring(0, 30)}... */}
                  </h3>

                  <div className="space-y-6">
                    {/* Full Business Plan */}
                    <div className="flex items-start">
                      <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                        <FileText className="h-5 w-5 text-emerald-600" />
                      </div>
                      <div className="ml-4">
                        <h4 className="font-semibold text-gray-900">
                          Go All in with this Idea.Unlock a 100+ page comprehensive report tailored to your concept — including:
                        </h4>
                        {/* <h4 className="font-semibold text-gray-900">Get Utmost Clarity with 100+ Page Business Report (Bestseller)</h4> */}
                        <p className="text-gray-700 mt-1">
                          Custom market research, Step-by-step go-to-market strategy, Early risk detection, Competitive moat
                          analysis,Business model clarity ,execution roadmap and 50+ more expert-built sections to guide your launch with
                          confidence.
                          {/* 100+ Page comprehensive report,Step by Step Goto Market Plan, Detect Early risks, Build
                          your moat,Custom Research only for this idea, cover every aspect of your business detail. */}
                          {/* Get unmatched clarity with tailored market sizing, deep competitor insights, realistic financial projections, and
                          a complete go-to-market strategy — trusted by thousands of founders. */}
                        </p>
                      </div>
                    </div>

                    {/* LeadFinder Tool */}
                    <div className="flex items-start">
                      <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center">
                        <Users className="h-5 w-5 text-purple-600" />
                      </div>
                      <div className="ml-4">
                        <h4 className="font-semibold text-gray-900">Go Beyond the Idea — Find Your First Users</h4>
                        <p className="text-gray-700 mt-1">
                          From a single platform, discover and target high-intent leads already looking for solutions like yours — across
                          Reddit, Twitter, and LinkedIn.
                          {/* We've identified <span className="font-medium">{Math.floor(result.demand_score / 10) + 5}+ people</span>{" "}
                          discussing needs related to "{result.sentiment[0]?.substring(0, 30)}..." across{" "}
                          {result.sources.slice(0, 2).join(" and ")}. Our LeadFinder tool shows you exactly who to contact. */}
                        </p>
                      </div>
                    </div>

                    {/* TikTok Tool */}
                    <div className="flex items-start">
                      <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-pink-100 flex items-center justify-center">
                        <Video className="h-5 w-5 text-pink-600" />
                      </div>
                      <div className="ml-4">
                        <h4 className="font-semibold text-gray-900">Automate TikTok and Reels at Scale </h4>
                        <p className="text-gray-700 mt-1">
                          UGC-style TikToks and Instagram Reels are the top drivers of product awareness today. Choose from 50+
                          hyper-realistic hooks and generate scroll-stopping content that drives traffic and builds brand momentum — all in
                          just 3 clicks.
                          {/* Test those TikTok concepts with our AI avatars - <span className="font-medium">no filming needed</span>. Create
                          30+ variations in minutes to see which messaging about "{result.recommended_angle?.substring(0, 40)}..." gets the
                          most engagement. */}
                        </p>
                      </div>
                    </div>

                    {/* Ideation Tool */}
                    <div className="flex items-start">
                      <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center">
                        <Sparkles className="h-5 w-5 text-blue-600" />
                      </div>
                      <div className="ml-4">
                        <h4 className="font-semibold text-gray-900">Brainstorm High-Impact Opportunities</h4>
                        <p className="text-gray-700 mt-1">
                          Find features, offers, and pain points worth solving. Tap into live conversations across Reddit, Twitter, and
                          LinkedIn to uncover real demand — not guesses.
                          {/* Your {result.demand_score}/100 validation highlights interest in aspects of{" "}
                          {result.competitors.slice(0, 2).join(" and ")}. Our brainstorming tool helps you explore related high-impact
                          features to build a truly <span className="font-medium">competitive solution</span>. */}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* CTA Button */}
                  <div className="mt-8">
                    <a
                      href={getCheckoutUrl()}
                      className="block w-full text-center px-6 py-4 bg-green-500 animate-pulse hover:bg-green-600 text-white font-medium rounded-lg transition-all shadow-md"
                    >
                      🔓 Unlock Everything for Just $59/month. Click to buy <ChevronRight className="inline-block ml-1 h-4 w-4" />
                    </a>
                    <p className="text-center text-sm text-gray-600 mt-3">
                      ✔ 4 Powerful Tools ✔ Full access instantly ✔ Trusted by 10,000+ founders
                      {/* ✔ Cancel anytime ✔ Full access instantly ✔ Trusted by 10,000+ founders */}
                    </p>
                  </div>
                </div>
                {/* <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">💰 Let's Build This Idea — Fully Done For You</h3>
                  <p className="text-gray-700 mb-4">You've validated it. Now let AI:</p>
                  <ul className="mb-6 space-y-2">
                    {[
                      "🧠 Write your 100+ Page Investor-Ready Plan",
                      "🧲 Find Real Leads already searching for your solution",
                      "🎥 Auto-generate TikToks/Reels — no camera, no editing",
                      "📦 Exportable Docs, Pitch Decks, GTM Strategy",
                    ].map((item, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="ml-1 text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href={getCheckoutUrl()}
                    className="block w-full text-center px-6 py-3 bg-green-500 hover:bg-green-700 text-white font-medium rounded-lg transition-colors"
                  >
                    Start Building → $59/month <ChevronRight className="inline-block ml-1 h-4 w-4" />
                  </a>
                  <p className="text-center text-sm text-gray-600 mt-3">
                    ✔ Cancel anytime ✔ Full access instantly ✔ Trusted by 10,000+ founders
                  </p>
                </div> */}
              </>
            )}
          </div>

          {/* Feedback section */}
          {/* <div className="border-t border-gray-200 p-6">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              <div className="text-sm text-gray-700">Was this analysis helpful? Help us improve our AI.</div>
              <div className="flex gap-3">
                <button
                  onClick={() => handleFeedback("helpful")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
                    voted === "helpful"
                      ? "bg-emerald-100 text-emerald-700 border border-emerald-200"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
                  }`}
                  disabled={voted !== null}
                >
                  <ThumbsUp className="h-4 w-4" />
                  Helpful
                </button>
                <button
                  onClick={() => handleFeedback("not_helpful")}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all ${
                    voted === "not_helpful"
                      ? "bg-red-100 text-red-700 border border-red-200"
                      : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-transparent"
                  }`}
                  disabled={voted !== null}
                >
                  <ThumbsDown className="h-4 w-4" />
                  Not Accurate
                </button>
              </div>
            </div>
          </div> */}
        </div>

        {/* Actions */}
        {/* <div className="flex flex-col sm:flex-row justify-between gap-4">
          <a
            href="/tools/free-startup-idea-validator/"
            className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            Want to Try Another Idea?
          </a>
          <div className="flex gap-2">
            <a
              href="/"
              className="flex-1 sm:flex-initial flex items-center justify-center gap-2 px-5 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 transition-colors shadow-sm"
            >
              Explore all tools 👉
            </a>
          </div>
        </div> */}

        {/* Platform showcase section */}
        <div className="mt-12 mb-16">
          {/* Heading */}
          <div className="text-center mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Everything You need to Run your Business Successfully</h2>
          </div>

          {/* Features grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Business Plan - highlight differently */}
            <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl overflow-hidden border border-emerald-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="h-10 w-10 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-600 flex items-center justify-center flex-shrink-0">
                    <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <div className="inline-block px-2 py-0.5 bg-white bg-opacity-50 rounded-full text-xs font-medium text-emerald-800 mb-1">
                      MOST POPULAR
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">100+ Page Business Plan</h3>
                    <p className="text-sm text-gray-700 mt-1">
                      Get unmatched clarity with tailored market sizing, deep competitor insights, realistic financial projections, and a
                      complete go-to-market strategy — trusted by thousands of founders.
                    </p>
                    <a
                      href="/dynamicreports/"
                      className="mt-3 inline-flex items-center text-emerald-600 font-medium text-sm hover:text-emerald-700"
                    >
                      Create Your Plan <ArrowRight className="ml-1 h-3 w-3" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Buyer Intent Search */}
            <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                    <svg className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <div className="inline-block px-2 py-0.5 bg-purple-100 rounded-full text-xs font-medium text-purple-800 mb-1">
                      POPULAR
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">Real-Time Buyer Intent Search</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      Find leads already searching for solutions like yours. Get auto-qualified, ranked buyer signals from live
                      conversations — warm DMs replace cold outreach.
                    </p>
                    <a
                      href="/leadfinder/"
                      className="mt-3 inline-flex items-center text-purple-600 font-medium text-sm hover:text-purple-700"
                    >
                      Discover Leads <ArrowRight className="ml-1 h-3 w-3" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* TikTok/Reels */}
            <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="h-10 w-10 rounded-lg bg-pink-100 flex items-center justify-center flex-shrink-0">
                    <svg className="h-5 w-5 text-pink-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">Launch Your AI Influencer</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      Your content team — without the overhead. Create daily TikToks, Reels, and Shorts using 50+ AI avatars. No camera, no
                      editing, just scroll-stopping videos that convert.
                    </p>
                    <a href="/video/" className="mt-3 inline-flex items-center text-pink-600 font-medium text-sm hover:text-pink-700">
                      Generate Videos <ArrowRight className="ml-1 h-3 w-3" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Brainstorm tool */}
            <div className="bg-white rounded-xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                    <svg className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-gray-900">Brainstorm High-Impact Opportunities</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      Find features, offers, and pain points worth solving. Tap into live conversations across Reddit, Twitter, and LinkedIn
                      to uncover real demand — not guesses.
                    </p>
                    <a href="/ideate/" className="mt-3 inline-flex items-center text-blue-600 font-medium text-sm hover:text-blue-700">
                      Start Discovering <ArrowRight className="ml-1 h-3 w-3" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <EnhancedFooter />
    </div>
  );
};

export default FreeIdeaValidatorResultsPage;
